import { Injectable, EventEmitter } from '@angular/core';
import { OpenFilterOptions } from './open-filter-options.model';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { ColumnType } from '../../models/filter.model';
import { getPropertyTypeBySystemType } from 'src/app/reports/helpers/property-type.helper';
import { PropertyType } from 'src/app/reports/shared/rte-form/schema/property-type.enum';

@Injectable({
  providedIn: 'root'
})
export class FilterOptionsService {

  onOpenFilterOptions: EventEmitter<OpenFilterOptions> = new EventEmitter<OpenFilterOptions>();

  constructor() { }

  openFilterOptions(option: OpenFilterOptions) {
    this.onOpenFilterOptions.emit(option);
  }

  getFilterTypeOptions(): ObjectValue[] {
    return [
      new ObjectValue('Igualdade (=)', FilterTypeEnum.Equal),
      new ObjectValue('Conteúdo de palavra (Like)', FilterTypeEnum.Like),
      new ObjectValue('Intervalo de valores (In)', FilterTypeEnum.Interval),
      new ObjectValue('Intervalo de data (Between)', FilterTypeEnum.Between),
      new ObjectValue('Maior (>)', FilterTypeEnum.Higher),
      new ObjectValue('Maior ou igual (>=)', FilterTypeEnum.HigherOrEqual),
      new ObjectValue('Menor (<)', FilterTypeEnum.Lower),
      new ObjectValue('Menor ou igual (<=)', FilterTypeEnum.LowerOrEqual),
      new ObjectValue('Lista de informação (=)', FilterTypeEnum.List),
      new ObjectValue('Multi-Lista de informação (In)', FilterTypeEnum.MultiList)
    ];
  }

  getFilterTypeOptionsByColumnType(columnType: ColumnType) {
    const type = getPropertyTypeBySystemType(columnType.SystemType),
      options = this.getFilterTypeOptions(),
      ignore = [];

    if (type !== PropertyType.Text) {
      ignore.push(FilterTypeEnum.Like);
    } else {
      ignore.push(FilterTypeEnum.Higher);
      ignore.push(FilterTypeEnum.HigherOrEqual);
      ignore.push(FilterTypeEnum.Lower);
      ignore.push(FilterTypeEnum.LowerOrEqual);
    }

    if (type === PropertyType.Date) {
      ignore.push(FilterTypeEnum.Interval);
      ignore.push(FilterTypeEnum.List);
      ignore.push(FilterTypeEnum.MultiList);
    } else {
      ignore.push(FilterTypeEnum.Between);
    }

    return options.filter(x => !ignore.includes(x.Value));
  }
}
